// eslint-disable-next-line boundaries/element-types
import { FileSuffix } from "../../../../pcb/layout_engine/models";
// eslint-disable-next-line boundaries/element-types
import { KiCadv3FootprintImporter } from "./v3/KiCadv3/KiCadFootprintImporter";
// eslint-disable-next-line boundaries/element-types
import { convertFootprintToFluxFootprintMap, KiCadFootprintImporter as KiCadv4FootprintImporter, } from "./v4/footprint/KiCadFootprintImporter";
const getImporterForFileExtension = (moduleSuffix, moduleData) => {
    switch (moduleSuffix) {
        case FileSuffix.modFile: {
            return new KiCadv3FootprintImporter(moduleData);
        }
        case FileSuffix.kicadModFile: {
            return new KiCadv4FootprintImporter(moduleData);
        }
    }
};
// This function is injected into contexts that don't have build time access
// to the v3 KiCad footprint importer. We also only have the file suffix
// (which is used to determine which importer to use) at runtime.
// This function currently both determines which importer to use and
// converts the footprint data to a Flux footprint.
export const convertLegacyOrModernKiCadFootprintToFluxFootprint = (moduleSuffix, moduleData) => {
    //
    const importer = getImporterForFileExtension(moduleSuffix, moduleData);
    return convertFootprintToFluxFootprintMap(moduleData, importer);
};
//# sourceMappingURL=KicadToFlux.js.map